import React from 'react'
import compose from 'recompose/compose'
import pure from 'recompose/pure'
import injectSheet from 'react-jss'

import Scene from 'aria-viewer/players/three/Mesh'

import PositionalMediaWrapper from './2d/positionalMedia/PositionalMediaWrapper'
import Modal from '../containers/modal/Modal'
import Hotspot from '../containers/hotspot/Hotspot'
import Trigger from '../containers/trigger/Trigger'
import Preview from '../containers/preview/Preview'

import { INTERACTIVE_ELEMENT_OPTIONS } from '../constants'

const style = theme => ({
    previewPosition: {
        zIndex: 501,
    },
})

const InteractiveElementsContainer = ({
    hotspots,
    triggers,
    positionalMedia,
    classes,
    setAutoRotate,
    stopId,
    scene,
    camera,
    renderer,
    mainSceneImageResource,
    contextType,
}) => (
    <div>
        <div className="interactiveElementContainer view">
            <Scene camera={camera} renderer={renderer} obj={scene}>
                <Preview contextType={contextType} positionClass={classes.previewPosition} />
                {hotspots.length > 0 &&
                    hotspots.map((id, i) => (
                        <Hotspot
                            setAutoRotate={setAutoRotate}
                            index={i}
                            key={id}
                            id={id}
                            stopId={stopId}
                            scene={scene}
                            camera={camera}
                            renderer={renderer}
                            contextType={contextType}
                        />
                    ))}
                {triggers.length > 0 &&
                    triggers.map((id, idx) => (
                        <Trigger
                            setAutoRotate={setAutoRotate}
                            key={id}
                            id={id}
                            idx={idx}
                            stopId={stopId}
                            scene={scene}
                            camera={camera}
                            renderer={renderer}
                            mainSceneImageResource={mainSceneImageResource}
                            contextType={contextType}
                        />
                    ))}
            </Scene>
        </div>
        <Modal />
        <PositionalMediaWrapper
            positionalMedia={positionalMedia}
            scene={scene}
            camera={camera}
            renderer={renderer}
            contextType={contextType}
        />
    </div>
)

InteractiveElementsContainer.defaultProps = {
    contextType: INTERACTIVE_ELEMENT_OPTIONS.CONTEXT.context3D,
}

export default compose(
    injectSheet(style),
    pure
)(InteractiveElementsContainer)
